<template>
  <div>
    <span class="name"><img
      v-if="community.type.toLowerCase() === 'private'"
      src="@/assets/PrivateCommunityIcon.svg"
    /> {{ community.name }}</span>
    <div v-if="community.description">
      <div
        class="content"
        v-html="communityDescription"
        v-linkify
        :title="community.description"
      />
    </div>
  </div>
</template>

<script>
import linkify from 'vue-linkify'

export default {
  name: 'CommunitySearch',
  props: {
    community: {
      type: Object,
      required: true
    }
  },
  directives: {
    linkify
  },
  computed: {
    description () {
      return this.community.description
    },
    communityDescription() {
      if (this.description.length > 100) {
        let trimmedDescription = this.description.substring(0, 100)
        return trimmedDescription.substr(0, Math.min(trimmedDescription.length, trimmedDescription.lastIndexOf(' '))).concat(' ...')
      }
      return this.description
    }
  }
}
</script>

<style scoped lang="scss">

.more {
    display: flex;
    justify-content: flex-end;
    color: $primary-color;
    font-weight: 600;
    margin-right: 1rem;
    font-size: 16px;
    text-decoration: none;

    img {
        margin-top: 1px;
    }
}

.name {
    font-weight: 700;
    color: $primary-color;
    font-size: 16px;
}

.content {
  overflow-wrap: break-word;
}

</style>
